import { createSlice } from '@reduxjs/toolkit';
import { makePropertyReducer } from 'store/utils';
import { CheckoutCurrencyState } from './types';

const getPropertyReducer = makePropertyReducer<CheckoutCurrencyState>();

const initialState: CheckoutCurrencyState = {
  userSelectedCurrency: '',
};

const checkoutCurrencySlice = createSlice({
  name: 'checkoutCurrency',
  initialState,
  reducers: {
    ...getPropertyReducer('userSelectedCurrency'),
  },
});

const {
  actions: { setUserSelectedCurrency },
  reducer: checkoutCurrencyReducer,
} = checkoutCurrencySlice;

export { setUserSelectedCurrency, checkoutCurrencyReducer };
